/**
 * Shared formatting utilities for lending/borrow components.
 */
export function useLendFormatters() {
    const PROTOCOL_LABELS = {
        'kamino': 'Kamino',
        'drift': 'Drift',
        'marginfi': 'MarginFi',
        'jup-lend': 'Jupiter',
        'loopscale': 'Loopscale',
    };

    function capitalize(str) {
        if (!str) return '';
        return PROTOCOL_LABELS[str.toLowerCase()] || str.charAt(0).toUpperCase() + str.slice(1);
    }

    function formatApy(val) {
        if (!val || val === 0) return '—';
        return Number(val).toFixed(2) + '%';
    }

    function formatCompact(val) {
        if (!val) return '0';
        if (val >= 1_000_000_000) return (val / 1_000_000_000).toFixed(1) + 'B';
        if (val >= 1_000_000) return (val / 1_000_000).toFixed(1) + 'M';
        if (val >= 1_000) return (val / 1_000).toFixed(1) + 'K';
        return Number(val).toFixed(val >= 1 ? 0 : 2);
    }

    function formatAmount(val) {
        if (!val) return '0';
        return Number(val).toLocaleString(undefined, { maximumFractionDigits: 4 });
    }

    return { capitalize, formatApy, formatCompact, formatAmount };
}
